import { createAction } from '@reduxjs/toolkit'

export interface UserTabItem {
  active: boolean
  userId: number
  displayName: string
}

export enum UserTabType {
  Home,
  MassMessage,
  User,
}

export interface CreatorTabItem {
  active: boolean
  creatorId: number
  activeUserTabType: UserTabType
  homeTabFanUserId?: number
  massMassageTabVisible: boolean
  userTabItems: UserTabItem[]
}

export const creatorTabNamespace = 'creatorTab'

export const activateCreatorTab = createAction<number>(`${creatorTabNamespace}/activateCreatorTab`)
export const removeCreatorTab = createAction<number>(`${creatorTabNamespace}/removeCreatorTab`)
export const addCreatorTab = createAction<CreatorTabItem>(`${creatorTabNamespace}/addCreatorTab`)
export const rearrangeCreatorTabs = createAction<CreatorTabItem[]>(`${creatorTabNamespace}/rearrangeCreatorTab`)
export const deactivateAllCreatorTabs = createAction(`${creatorTabNamespace}/deactivateAllCreatorTabs`)
export const removeUserTab = createAction<{
  creatorId: number,
  userId: number
}>(`${creatorTabNamespace}/removeUserTab`)
export const activateUserTab = createAction<{
  creatorId: number,
  userId: number
}>(`${creatorTabNamespace}/activateUserTab`)
export const rearrangeUserTabs = createAction<{
  creatorId: number,
  userTabItems: UserTabItem[]
}>(`${creatorTabNamespace}/rearrangeUserTabs`)
export const addUserTab = createAction<{
  creatorId: number
  userTabItem: UserTabItem
}>(`${creatorTabNamespace}/addUserTab`)
export const updateHomeTabFanUserId = createAction<{
  creatorId: number
  fanUserId?: number
}>(`${creatorTabNamespace}/updateHomeTabFanUserId`)
export const updateActiveUserTabType = createAction<{
  creatorId: number
  userTabType: UserTabType
}>(`${creatorTabNamespace}/updateActiveUserTabType`)
export const updateMassMassageTabVisible = createAction<{
  creatorId: number
  visible: boolean
}>(`${creatorTabNamespace}/updateMassMassageTabVisible`)
